/**
 * CloudFront signed media URLs authorize via query params. `credentials: 'include'`
 * fails CORS: f.{env} uses ACAO `*` without Allow-Credentials.
 * Legacy cookie-host URLs still need cookies.
 */
export const mediaFetchCredentials = url => {
  if (!url || typeof url !== 'string') {
    return 'include';
  }
  try {
    const parsed = new URL(url, 'https://f.ommnio.com');
    if (
      parsed.searchParams.has('Policy') ||
      parsed.searchParams.has('Signature') ||
      parsed.searchParams.has('Key-Pair-Id')
    ) {
      return 'omit';
    }
  } catch {
    // keep include
  }
  return 'include';
};
